/*! Lazy Image with Vanilla Lazyload Integration */

// LazyImage sınıfı - loading animasyonu için
class LazyImage extends HTMLImageElement {
  constructor() {
    super();

    this.wrapper = this.closest(".media-wrapper");
    if (this.wrapper === null) return;

    this.handleLazy();
    addEventListener("resize", this.handleLazy.bind(this), true);

    const observer = new MutationObserver((changes) => {
      changes.forEach((change) => {
        if (
          change.attributeName.includes("src") ||
          change.attributeName.includes("srcset")
        ) {
          this.handleLazy();
        }
      });
    });
    observer.observe(this, { attributes: true });
  }

  handleLazy() {
    const mql = window.matchMedia("(min-width: 750px)");
    if (mql.matches && this.classList.contains("medium-hide")) return;
    if (!mql.matches && this.classList.contains("small-hide")) return;
    if (this.complete || this.classList.contains("loaded")) return;

    this.wrapper.classList.add("loading");
    this.addEventListener(
      "load",
      () => {
        const loaded = () => {
          this.classList.add("loaded");
          this.wrapper.classList.remove("loading");
        };

        window.requestIdleCallback
          ? window.requestIdleCallback(loaded, { timeout: 150 })
          : setTimeout(loaded);
      },
      false
    );
  }
}
window.customElements.define("lazy-image", LazyImage, { extends: "img" });

// ProgPicture sınıfı - yüksek kalite resim için
class ProgPicture extends HTMLPictureElement {
  constructor() {
    super();

    this.abortController = new AbortController();
    this.addEventListener("touchmove", this.touchmove_handler, {
      signal: this.abortController.signal,
    });
  }

  touchmove_handler(ev) {
    if (ev.scale > 1) {
      var hqImage = this.getAttribute("data-hq");
      this.querySelector("source").setAttribute("srcset", hqImage);
      this.abortController.abort();
    }
  }
}
window.customElements.define("prog-picture", ProgPicture, {
  extends: "picture",
});

// Vanilla Lazyload Entegrasyonu
(function () {
  "use strict";

  // DOM hazır olduğunda çalıştır
  function initLazyLoad() {
    // is="lazy-image" olan tüm resimleri bul
    const lazyImages = document.querySelectorAll(
      'img[is="lazy-image"]:not(.lazyload-processed)'
    );

    lazyImages.forEach(function (img) {
      // Zaten işlendiyse atla
      if (img.classList.contains("lazyload-processed")) return;

      // Eğer resim zaten görünür alanda veya yüklendiyse atla
      if (img.complete && img.naturalWidth > 0) {
        img.classList.add("lazyload-processed", "loaded");
        return;
      }

      // src ve srcset değerlerini data-src ve data-srcset'e taşı
      const currentSrc = img.getAttribute("src");
      const currentSrcset = img.getAttribute("srcset");
      const currentSizes = img.getAttribute("sizes");

      if (currentSrc) {
        img.setAttribute("data-src", currentSrc);
        // Küçük placeholder veya boş gif kullan
        img.setAttribute(
          "src",
          "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
        );
      }

      if (currentSrcset) {
        img.setAttribute("data-srcset", currentSrcset);
        img.removeAttribute("srcset");
      }

      if (currentSizes) {
        img.setAttribute("data-sizes", currentSizes);
      }

      // lazyload class'ını ekle
      img.classList.add("lazyload", "lazyload-processed");

      // Native loading="lazy" özelliğini kaldır (vanilla-lazyload kullanacağız)
      img.removeAttribute("loading");
    });

    // Picture elementleri içindeki source'ları da işle
    const lazyPictures = document.querySelectorAll(
      'picture:has(img[is="lazy-image"].lazyload)'
    );
    lazyPictures.forEach(function (picture) {
      const sources = picture.querySelectorAll("source");
      sources.forEach(function (source) {
        const srcset = source.getAttribute("srcset");
        if (srcset && !source.hasAttribute("data-srcset")) {
          source.setAttribute("data-srcset", srcset);
          source.removeAttribute("srcset");
        }
      });
    });

    // Vanilla Lazyload'u başlat veya güncelle
    if (typeof LazyLoad !== "undefined") {
      if (window.lazyLoadInstance) {
        window.lazyLoadInstance.update();
      } else {
        window.lazyLoadInstance = new LazyLoad({
          elements_selector: ".lazyload",
          threshold: 300, // Viewport'a 300px kala yüklemeye başla
          thresholds: "300px 0px", // Üst ve alt threshold
          class_loading: "lazyloading",
          class_loaded: "lazyloaded",
          class_error: "lazyerror",
          use_native: false, // Vanilla lazyload kullan, native kullanma
          callback_enter: function (el) {
            // Resim viewport'a girdiğinde
            const wrapper = el.closest(".media-wrapper");
            if (wrapper) {
              wrapper.classList.add("loading");
            }
          },
          callback_loaded: function (el) {
            // Resim yüklendiğinde
            el.classList.add("loaded");
            const wrapper = el.closest(".media-wrapper");
            if (wrapper) {
              if (window.requestIdleCallback) {
                window.requestIdleCallback(
                  function () {
                    wrapper.classList.remove("loading");
                  },
                  { timeout: 150 }
                );
              } else {
                setTimeout(function () {
                  wrapper.classList.remove("loading");
                }, 0);
              }
            }
          },
          callback_error: function (el) {
            // Resim yüklenemediğinde
            el.classList.add("lazyerror");
            const wrapper = el.closest(".media-wrapper");
            if (wrapper) {
              wrapper.classList.remove("loading");
            }
          },
        });
      }
    } else {
      // Vanilla Lazyload yüklenmediyse, fallback olarak native loading kullan
      console.warn("Vanilla Lazyload not loaded, using native loading");
      lazyImages.forEach(function (img) {
        if (img.classList.contains("lazyload")) {
          const dataSrc = img.getAttribute("data-src");
          const dataSrcset = img.getAttribute("data-srcset");
          if (dataSrc) img.setAttribute("src", dataSrc);
          if (dataSrcset) img.setAttribute("srcset", dataSrcset);
          img.setAttribute("loading", "lazy");
          img.classList.remove("lazyload");
        }
      });
    }
  }

  // Sayfa yüklendiğinde başlat
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initLazyLoad);
  } else {
    initLazyLoad();
  }

  // MutationObserver ile dinamik eklenen resimleri de yakala
  const bodyObserver = new MutationObserver(function (mutations) {
    let hasNewImages = false;
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) {
          // Eklenen element bir img mi veya içinde img var mı?
          if (
            node.matches &&
            node.matches('img[is="lazy-image"]:not(.lazyload-processed)')
          ) {
            hasNewImages = true;
          } else if (node.querySelectorAll) {
            const imgs = node.querySelectorAll(
              'img[is="lazy-image"]:not(.lazyload-processed)'
            );
            if (imgs.length > 0) hasNewImages = true;
          }
        }
      });
    });

    if (hasNewImages) {
      // Yeni resimler eklendiyse lazyload'u güncelle
      requestAnimationFrame(initLazyLoad);
    }
  });

  // Body'yi izle
  if (document.body) {
    bodyObserver.observe(document.body, { childList: true, subtree: true });
  } else {
    document.addEventListener("DOMContentLoaded", function () {
      bodyObserver.observe(document.body, { childList: true, subtree: true });
    });
  }

  // Shopify section render event'lerini dinle (Ajax ile section güncellemelerinde)
  document.addEventListener("shopify:section:load", initLazyLoad);
  document.addEventListener("shopify:section:reorder", initLazyLoad);

  // Global fonksiyon olarak da erişilebilir yap
  window.refreshLazyLoad = initLazyLoad;
})();
